import React, { type FC } from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { BreadcrumbsPlaceholder } from '../src/BreadcrumbsPlaceholder.tsx';
import type { BreadcrumbsProps } from '../src/Breadcrumbs.tsx';

export const BreadcrumbsLoader: LoadableType<BreadcrumbsProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Breadcrumbs" */ '../src/Breadcrumbs.tsx'))
			.Breadcrumbs,
	loading: BreadcrumbsPlaceholder,
});
export const Breadcrumbs: FC<BreadcrumbsProps> = (props) => <BreadcrumbsLoader {...props} />;

export const FixedBreadcrumbsNavForPageLayoutLoader: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Breadcrumbs" */ '../src/Breadcrumbs.tsx'))
			.FixedBreadcrumbsNavForPageLayout,
});
